<template>
  <div class="menu-side-wrap">
    <div class="resultsLeft">
      <div class="resultTop">
        <div class="searchTotal">
          <div>检索结果</div>
          <div class="number">{{selectRow}}/{{total}}</div>
        </div>
        <div class="resultsRow">
          <div v-for="(item,index) in resultList" :key="index" :title="item.title" :class="[activeIndex===index ? 'activeResult' : '']" @click="resultRowClick(item,index)">{{index+1}}.{{item.title}}</div>
        </div>
      </div>
      <div class="resultBtn">
        <a-button class="btnUpper" @click="back">返回</a-button>
        <a-button class="btnUpper" v-if="isShowUpper" @click="btnUpperClick">上一页</a-button>
        <a-button class="btnLower" v-if="isShowLower" @click="btnLowerClick">下一页</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { competitorDatabaseSearch } from '@/api/resultSearch'
import { requestCols } from '../config/index'
import { getStorage } from '@/utils'

const { mapGetters } = require('vuex')

export default {
  data() {
    return {
      requsetParams: {},
      // detailParams: JSON.parse(JSON.stringify(requsetParams)),
      detailParams: {},
      isShowUpper: false, // 是否显示上一页按钮
      isShowLower: true,
      resultList: [], // 检索结果
      total: 0,
      activeIndex: 0
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getRequsetParams'
    ]),
    selectRow() {
      return this.activeIndex + 1 + this.requsetParams.offset
    }
  },
  mounted() {
    const linkParams = getStorage('requsetParams', 0)
    const requsetParams = JSON.parse(linkParams.requestParams)
    requsetParams.requestCols = requestCols
    this.requsetParams = requsetParams
    this.activeIndex = Number(this.$route.query.index)
    this.initResult()
  },
  methods: {
    initResult() {
      competitorDatabaseSearch(this.requsetParams).then((res) => {
        if (res.code === 200) {
          const resultList = JSON.parse(res.data)
          this.resultList = resultList.result
          this.total = resultList.total
          this.getDetail(this.resultList[this.activeIndex])
          this.$emit('getResult', this.resultList[this.activeIndex])
          if (this.total - this.requsetParams.pageSize > this.requsetParams.offset && this.total > this.requsetParams.pageSize) { // 下
            this.isShowLower = true
          } else {
            this.isShowLower = false
          }

          if (this.requsetParams.offset > 0) { // 上
            this.isShowUpper = true
          } else {
            this.isShowUpper = false
          }
        }
      })
    },
    // 获取详情
    getDetail(val) {
      const searchExpre = `公开号=('${val.publication_number_sear}') and 申请号=('${val.application_num_sear}')`
      const requsetParams = JSON.parse(JSON.stringify(this.requsetParams))
      requsetParams.searchExpre = searchExpre
      requsetParams.offset = 0
      competitorDatabaseSearch(requsetParams).then((res) => {
        if (res.code === 200) {
          const detailVal = JSON.parse(res.data).result
          this.$emit('getDetail', detailVal)
        }
      })
    },
    btnLowerClick() {
      this.requsetParams.offset += this.requsetParams.pageSize
      this.activeIndex = 0
      this.$bus.$emit('reductionChange')
      this.initResult()
    },
    btnUpperClick() {
      this.requsetParams.offset -= this.requsetParams.pageSize
      this.activeIndex = 0
      this.$bus.$emit('reductionChange')
      this.initResult()
    },
    resultRowClick(val, index) {
      this.activeIndex = index
      this.$bus.$emit('reductionChange')
      this.getDetail(val)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
